module.exports = __webpack_public_path__ + "a8be5d4e89f0999ffdbb607ddb1e6bf8.MP3";